import { Skeleton } from "@progress/kendo-react-indicators";
import React from "react";

export const CartLoadingUI = () => {
  return (
    <>
      <div className="cart-item">
        <div className="cart-img-container">
          <Skeleton
            shape={"rectangle"}
            style={{ width: "120px", height: "135px" }}
          ></Skeleton>
        </div>
        <p className="name">
          <Skeleton
            shape={"text"}
            style={{ width: "300px", height: "25px" }}
          ></Skeleton>
        </p>
        <p className="sku-container">
          <Skeleton
            shape={"text"}
            style={{ width: "140px", height: "25px" }}
          ></Skeleton>
        </p>
        <p className="price">
          <Skeleton
            shape={"text"}
            style={{ width: "80px", height: "25px" }}
          ></Skeleton>
        </p>
      </div>
      <div className="cart-buttons">
        {" "}
        <Skeleton
          shape={"rectangle"}
          style={{ width: "105px", height: "45px" }}
        ></Skeleton>
      </div>
    </>
  );
};
